import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Advantages from "@/components/Advantages";
import Catalog from "@/components/Catalog";
import Calculator from "@/components/Calculator";
import Keywords from "@/components/Keywords";
import Location from "@/components/Location";

export default function HomePage() {
  return (
    <main>
      <Seo
        title="CV. Sinar Al Mubarokah — Pabrik & Distributor Kayu Olahan Jakarta Murah"
        description="Pabrik kayu Jakarta murah dengan stok melimpah: balok meranti, kaso 4x6, triplek cor, kamper, bengkirai, ulin, merbau. Semua jenis & ukuran, harga langsung pabrik, kirim 24 jam se-Jabodetabek. WA 0822-8280-0020."
        path="/"
      />
      <Hero />
      <Marquee />
      <Advantages />
      <Catalog />
      <Calculator />
      <Keywords />
      <Location />
    </main>
  );
}
